import * as React from "react";
import { SVGProps } from "react";
const SvgArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={4}
    height={8}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m.541 7.835 3.237-3.29a.783.783 0 0 0 0-1.093L.54.162C.235-.15 0 .006 0 .487V7.51c0 .494.235.637.541.325Z"
      fill="#C7C8C9"
    />
  </svg>
);
export default SvgArrowRight;
